<template>
  <div class="member-breaking-container" @click="close">
    <div class="member-breaking-content">
      <img
        src="https://logo.wondercv.com/banners/08F7tmMpmyPiqMA.png"
        alt=""
        class="member-breaking-logo"
      />
      <img
        src="https://logo.wondercv.com/banners/XW5WiEXsR5Y3Mck.png"
        alt=""
        class="title-image"
      />
      <div class="desc-info-list">
        <div
          class="desc-info-item"
          v-for="(item, index) in descInfoArr"
          :key="index"
        >
          <img :src="item.image" alt="" />
          <span>{{ item.title }}</span>
        </div>
      </div>
      <div class="bottom-btn-content">
        <div class="bottom-btn-item" @click.stop="clickBtnItem('campus')">开通求职会员</div>
        <div class="bottom-btn-item" @click.stop="clickBtnItem('cv')">开通终身会员</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MemberBreakingModal",
  data() {
    return {
      descInfoArr: [
        {
          title: "永久求职信息服务",
          image: "https://logo.wondercv.com/banners/ohdvXSs6gPeYamZ.png",
        },
        {
          title: "永久校招日程管理",
          image: "https://logo.wondercv.com/banners/5ihSkx1R6qwoTvz.png",
        },
        {
          title: "无限次复制信息",
          image: "https://logo.wondercv.com/banners/1XXeLE1IAZ8vayX.png",
        },
        {
          title: "PC一键跳转企业官网投递",
          image: "https://logo.wondercv.com/banners/Q13Ns0lPplGJ6qJ.png",
        },
      ],
    };
  },
  methods: {
    clickBtnItem(type) {
      this.$emit("clickBtnItem", type);
    },
    close() {
      this.$emit('close')
    }
  },
};
</script>
<style lang="scss" scoped>
.member-breaking-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  .member-breaking-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 390px;
    height: 400px;
    border-radius: 24px;
    background: linear-gradient(
      180deg,
      #ffdbd3 0%,
      rgba(255, 255, 255, 1) 34.46%
    );
    padding: 61px 20px 31px;
    box-sizing: border-box;
    .member-breaking-logo {
      position: absolute;
      width: 162px;
      height: 158px;
      left: 50%;
      transform: translate(-50%, -50%);
      top: -10px;
    }
    .title-image {
      width: 224px;
      height: 34px;
      object-fit: contain;
      margin-bottom: 8px;
    }
    .desc-info-list {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      .desc-info-item {
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 16px;
        img {
          width: 40px;
          height: 40px;
          object-fit: contain;
          margin-bottom: 12px;
        }
        span {
          color: #1d2129;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
    .bottom-btn-content {
      display: flex;
      align-items: center;
      width: 100%;
      .bottom-btn-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 180px;
        height: 56px;
        color: #4b596b;
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
        margin-top: 24px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 0 10px;
        cursor: pointer;
        &:first-child {
          background-image: url("https://logo.wondercv.com/banners/y2s3LNYXLkcZERb.png");
          margin-right: -10px;
        }
        &:last-child {
          background-image: url("https://logo.wondercv.com/banners/6dRcA7lcGz9ktVE.png");
          margin-left: -10px;
          color: #fff;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
